import axios from '../utils/axios';

export default function addIntegrations(adminId, data) {
    return (
        axios.post(`/admin/${adminId}/ats-integrations`,  data )
    )
}
